import type { HTMLAttributes } from 'react'
import styled, { CSSProperties } from 'styled-components'

import { TAlignStyleProps, alignStyle } from '@hozana/styling/alignStyle'
import { mergeStyles } from '@hozana/styling/mergeStyles'
import { TResponsiveProps, mediaQuery, responsiveStyle } from '@hozana/styling/responsive'

const responsiveProps = { maxW: 'max-width', minH: 'min-height', p: 'padding', m: 'margin' } as const

export type TContainerProps = {
  noPrint?: boolean
} & Pick<CSSProperties, 'position'> &
  TResponsiveProps<typeof responsiveProps> &
  HTMLAttributes<HTMLDivElement> &
  TAlignStyleProps

export const Container = styled.div.attrs<TContainerProps, TContainerProps>(
  ({ align, column, position = 'relative', style }) => ({
    style: mergeStyles(style, {
      position,
      ...alignStyle({ align, column }),
    }),
  }),
)`
  ${({ p = { xs: '5px', sm: '30px 10px' }, m = '0px auto', maxW = '1010px', ...otherProps }) =>
    responsiveStyle(responsiveProps)({ p, m, maxW, ...otherProps })}

  ${mediaQuery('xs', 'md')} {
    width: 100%;
  }

  /* Print */
  ${(props) => props.noPrint && '@media print {display: none}'}
`
